import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import {
  OutboundIpResult,
  ServiceHealthSummary,
  SystemHealthReport,
  SystemHealthSummary,
  SystemHealthTarget,
} from '../models/system-health.model';

@Injectable({
  providedIn: 'root',
})
export class SystemHealthApiService {
  private readonly http = inject(HttpClient);
  private readonly api = environment.apiUrl.replace(/\/$/, '');

  getSystemHealthSummary(): Observable<SystemHealthSummary> {
    return this.http.get<SystemHealthSummary>(`${this.api}/system-health/summary`);
  }

  getServiceHealthSummary(target: SystemHealthTarget): Observable<ServiceHealthSummary> {
    return this.http.get<ServiceHealthSummary>(
      `${this.api}/system-health/${encodeURIComponent(target)}/summary`,
    );
  }

  getSystemHealth(target: SystemHealthTarget): Observable<SystemHealthReport> {
    return this.http.get<SystemHealthReport>(
      `${this.api}/system-health/${encodeURIComponent(target)}/details`,
    );
  }

  getOutboundIp(target: SystemHealthTarget): Observable<OutboundIpResult> {
    return this.http.get<OutboundIpResult>(
      `${this.api}/system-health/${encodeURIComponent(target)}/outbound-ip`,
    );
  }
}
